import { usePage } from "../../hooks/usePage";

export default function Settings() {
  usePage({ title: "Configuración" });
  return <h1>Settings</h1>;
}
